<template>
<div id="treaty">
  <div class="container">
    <h2 v-if="!$route.query.lang" class="treaty-title">{{$t('user.treaty_title')}}</h2>
    <div v-html="$t('user.treaty')"></div>
  </div>
</div>
</template>
<script>
export default {
  data() {
    return {
    }
  },
  mounted(){
    if(this.$route.query.lang ){
      this.$i18n.locale = this.$route.query.lang 
      document.title = this.$t('user.treaty_title')
    }
  },
}
</script>
<style lang="scss">
#treaty{
  font-size: 1.4rem;
  line-height: 2rem;
  padding: 1rem 1.2rem;
  .treaty-title{
    text-align: center;
    margin-bottom: 1rem;
  }
  .subtitle{
    font-weight: 600;
    text-indent: 0;
  }
  p{
    text-indent: 1em;
  }
}
</style>